module.exports = __webpack_public_path__ + "img/40_38_071_900.c367220f.jpg";